import { defineFieldTypeTemplate } from '#layers/data-model/utils/field-types/define';

export default defineFieldTypeTemplate({
	type: 'primitive',
	id: 'color',
	name: '$t:field_types.color.name',
	description: '$t:field_types.color.description',
	icon: 'lucide:paint-bucket',
	sort: 1000,
	keywords: ['hex', 'rgb', 'picker'],
	supportedPrimitiveTypes: ['string'],
	// TODO allow user to configure presets
});
